import React from "react";
import "./style.less";

export default ({modal, children}) => {
    const type = modal ? 'modal' : 'inline';

    return (
        <div className={`page-loading-container loading-${type}`}>
            <div className="page-loading-image">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64">
                    <circle cx="32" cy="32" r="26" stroke="#369" strokeWidth="6" strokeLinecap="round" fill="none" className="loading-image-circle" />
                </svg>
                <p>{children || 'Загрузка...'}</p>
            </div>
        </div>
    );
};
